import { render, staticRenderFns } from "./virtualsimulationexperiment.vue?vue&type=template&id=5ea4443c&scoped=true"
import script from "./virtualsimulationexperiment.vue?vue&type=script&lang=js"
export * from "./virtualsimulationexperiment.vue?vue&type=script&lang=js"
import style0 from "./virtualsimulationexperiment.vue?vue&type=style&index=0&id=5ea4443c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea4443c",
  null
  
)

export default component.exports